import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Heading, Image, Stack, Text } from "@chakra-ui/react";

import { RoutesMap } from "../../../../../routes.tsx";
import successIcon from "../../../../../assets/successTick.png";
import { useSbpTransferStore } from "../../../../../store/sbpTransferStore.ts";
import { formatPriceWithoutZeros, isStringWithNumber } from "../../../../../utils";

export const SbpTransferResultPageSuccess: FC = () => {
  const navigate = useNavigate();
  const transferResult = useSbpTransferStore(state => state.transferResult);

  const amount = isStringWithNumber(transferResult?.amount)
    ? formatPriceWithoutZeros(Number(transferResult?.amount))
    : "";
  const bankName = transferResult?.bankName ? ` в ${transferResult.bankName}` : "";

  const onClick = () => {
    navigate(RoutesMap.index);
  };

  return (
    <Stack spacing={0} flex="1" alignItems="center" textAlign="center">
      <Image w="173px" h="98px" src={successIcon} mb="25px" />

      <Heading lineHeight="1" mb="2px">Перевод выполнен</Heading>
      <Heading mb="12px">{amount}</Heading>

      <Text fontSize="14px" mb="34px" lineHeight="1">
        {`отправлено через СБП${bankName}`}
      </Text>

      <Button w="100%" colorScheme="purple" onClick={onClick}>
        Вернуться на главную
      </Button>
    </Stack>
  );
};
